module.exports = (__webpack_require__(10))(3087);